var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-product-tile-review.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"c-product-tile__reviews c-product-tile__reviews--";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tileTemplate"), env.opts.autoescape);
output += "\" data-qa-product-tile-reviews>";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"reviews") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"reviews")),"averageRating") > 0) {
output += "<p>";
output += runtime.suppressValue((lineno = 1, colno = 61, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product-video-tile_average-rating"])), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((lineno = 1, colno = 111, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "round_step"), "round_step", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"reviews")),"averageRating")])), env.opts.autoescape);
output += "</p>";
;
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"reviews") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"reviews")),"count") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"reviews")),"count") > 0) {
output += "<p>";
output += runtime.suppressValue((lineno = 2, colno = 76, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product-video-tile_review-count"])), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"reviews")),"count"), env.opts.autoescape);
output += "</p>";
;
}
output += "</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-product-tile-review.j2"] , dependencies)